import React from 'react';
import { RunState } from '../../api';
import { isArray } from 'util';
import SelectMultiple, { OptionType } from './SelectMultiple';
import _ from 'underscore';

interface Props {
  statuses: Array<RunState>;
  onStatusesChange: (statuses: Array<RunState>) => void;
}

const SelectRunStatus: React.FunctionComponent<Props> = props => {
  let statuses: Array<OptionType> = [];

  statuses = Object.keys(RunState).map(pl => ({
    label: pl,
    //@ts-ignore
    value: RunState[pl as any],
  }));

  const selected = statuses.filter(p => _.contains(props.statuses, p.value));

  const onChange = (value: ReadonlyArray<OptionType> | OptionType | null | undefined) => {
    return value && isArray(value) ? props.onStatusesChange(value.map(v => v.value)) : props.onStatusesChange([]);
  };

  return (
    <SelectMultiple
      data={statuses}
      selected={selected}
      label="Run status"
      placeholder="Select run status"
      onChange={onChange}
    />
  );
};

export default SelectRunStatus;
